export default {"src":"/_next/static/media/instagram.ea8f49b1.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};